export async function setupHeaderOptions(apwConfig) {
  const apwHeaderOptions = apwConfig.APW_HEADER_OPTIONS;

  if (!apwHeaderOptions) return;

  if (apwHeaderOptions.apwHeaderItemsURL && !apwHeaderOptions.items) {
    try {
      const result = await fetch(apwHeaderOptions.apwHeaderItemsURL, { method: 'GET' });

      if (!result.ok) throw new Error(result.statusText);

      const responseData = await result.json();

      window.apwHeaderOptions.items = responseData;
      window.apwHeaderOptions = Object.freeze(window.apwHeaderOptions);
    } catch (e) {
      throw new Error(e);
    }
  }
}
